// extracted by mini-css-extract-plugin
export default {"container":"up-z","ratingLayout":"vp-z","ratingLabel":"wp-z","nonInteractiveRatingLabel":"xp-z"};